import { Component, OnInit, Input } from '@angular/core';
import { OrderService } from '../../order.service';
import { OrderShopifyDTO } from '../../../../../shared/order-shopify-dto';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountDTO } from '../../../../../shared/account-dto';
import { AccountService } from '../../account.service';

@Component({
  selector: 'pv-order-shopify',
  templateUrl: './order-shopify.component.html',
  styleUrls: ['./order-shopify.component.scss']
})
export class OrderShopifyComponent implements OnInit {
  @Input() urlToken: string;
  loggedIn: boolean;
  authorized: boolean;
  order: OrderShopifyDTO;
  loading: boolean = true;
  account: AccountDTO = { } as AccountDTO

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderService: OrderService,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    // Subscribe to account
    this.account = this.accountService.account
    this.accountService.accountSubject
    .subscribe(account => this.account = account)

    if (this.urlToken) {
      this.loadOrder(this.urlToken)
    } else {
      this.route.params.subscribe(params => {
        this.authorized = false;
        this.loadOrder(params.url_token)
      })
    }
  }

  // #1358
  loadOrder(url_token) {
    console.log(url_token);
    this.loading = true;
    this.orderService.getOrderShopifyByToken(url_token)
    .subscribe(order => {
      this.order = order
      this.authorized = true
      this.loading = false;
    }, err => {
      this.router.navigate(['/'])
    })
  }
}
